<template>
	<div class="container">
		<div class="header">
			<!-- 头部导航栏 -->
			<div class="nav">
				<div class="left_nav_box">
					<div class="leftNav">
						数据驾驶舱
					</div>
					<div class="leftNav" @click="goSystem()">
						系统管理
					</div>
					<div class="leftNav" @click="goVideo()">
						视频管理
					</div>
				</div>
				<div class="weather">
					<span style="color: #f7ed5a;">{{ year }} </span>
					<span style="color: #9ec5d3;">年</span>
					<span style="color: #f7ed5a;">{{ month }} </span>
					<span style="color: #9ec5d3;">月</span>
					<span style="color: #f7ed5a;">{{ day }} </span>
					<span style="color: #9ec5d3;">日</span>
					<span style="color: #f7ed5a;"> {{ currentDay }} </span>
					<span style="color: #9ec5d3;">{{ currentTime }}</span>
				</div>
				<div class="right_nav_box">
					<div class="rightNav" @click="goDevice()">
						设备管理
					</div>
					<div class="rightNav" @click="goApplication()">
						应用管理
					</div>
					<div class="rightNav" @click="goMap()">
						地图管理
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="leftBox">
				<div class="runstatus">
					<div class="leftTitle" style="margin-right: 84px;">
						智能设备运行状态
					</div>
					<div class="tip">设备联网</div>
					<div class="statusBox">
						<div class="online_box">
							<div style="color: #0cdace;margin-top: 8px;">在线</div>
							<div>{{onLineNum}}%</div>
						</div>
						<div class="offline_box">
							<div style="margin-top: 10px;">离线</div>
							<div>{{offLineNum}}%</div>
						</div>
						<div style="font-size: 12px;margin-top: 8px;color: #edeff1;">
							<div style="display: flex;flex-direction: row;align-items: center;">设备启用 <el-image
									:src="require('@/assets/circle.png')"></el-image>
							</div>
							<div>设备停用<span></span></div>
						</div>
					</div>
					<div style="margin: 0 auto;">
						<dv-percent-pond :config="scheduleConfig"
							style="width: 300px;height: 30px;margin: 0 auto;margin-top: 10px;" />
					</div>
				</div>
				<div class="oneclick" style="position: relative;">
					<div class="leftTitle" style="margin-right: 94px;">
						一键报警数据
					</div>
					<div class="oneClick_box" style="width: 60%;margin: 0 auto;margin-top: 60px;">
						<div style="position: absolute;top: 64px;left: 36px;">
							<div style="color:#cff8f9;font-size: 22px;">{{onezhi.egnum}}次</div>
							<div style="color: #0eeadb;font-size: 14px;">{{onezhi.deviceType}}</div>
						</div>
						<div style="position: absolute;right: 40px;top: 68px;">
							<div style="color:#cff8f9;font-size: 22px;">{{onejing.egnum}}次</div>
							<div style="color: #0eeadb;font-size: 14px;">{{onejing.deviceType}}</div>
						</div>
						<div style="position: absolute;top: 140px;left: 60px;">
							<div style="color:#cff8f9;font-size: 22px;">{{onexuan.egnum}}次</div>
							<div style="color: #0eeadb;font-size: 14px;">{{onexuan.deviceType}}</div>
						</div>
					</div>
				</div>
				<div class="serve">
					<div class="leftTitle" style="margin-right: 114px;">
						服务数据
					</div>
					<div class="serve_box" id="serve" :style="{ width: '520px', height: '220px' }"></div>
				</div>
			</div>
			<!-- 附图信息 -->
			<div class="map">
				<div class="point" style="position: absolute;top: 16%;right: 24%;">
					<!-- content="设备名称：多功能报警柱子 设备状态：在线" -->
					<el-popover placement="right-start" title="设备信息" width="200" trigger="hover">
						<div>
							设备名称：智能报警柱
						</div>
						<div>
							设备状态：{{jing.deviceStatus}}
						</div>
						<div>
							设备位置：{{jing.deviceLocation}}
						</div>
						<el-image style="width: 80px; height: 80px;" :src="require('../assets/baojing.png')"
							slot="reference"></el-image>
					</el-popover>
				</div>
				<div class="point" style="position: absolute;top: 20%;right: 36%;" @click="goGuide()">
					<el-popover placement="right-start" title="设备信息" width="200" trigger="hover">
						<div>
							设备名称：智能指路机
						</div>
						<div>
							设备状态：{{lu.deviceStatus}}
						</div>
						<div>
							设备位置：{{lu.deviceLocation}}
						</div>
						<el-image style="width: 80px; height: 80px;" :src="require('../assets/zhilu.png')"
							slot="reference"></el-image>
					</el-popover>
				</div>
				<div class="point" style="position: absolute;top: 28%;right: 40%;">
					<el-popover placement="right-start" title="设备信息" width="200" trigger="hover">
						<div>
							设备名称：数字坐凳
						</div>
						<div>
							设备状态：{{deng.deviceStatus}}
						</div>
						<div>
							设备位置：{{deng.deviceLocation}}
						</div>
						<el-image style="width: 80px; height: 80px;" :src="require('../assets/deng.png')"
							slot="reference"></el-image>
					</el-popover>
				</div>
				<div class="point" style="position: absolute;top: 34%;right: 46%;">
					<el-popover placement="right-start" title="设备信息" width="200" trigger="hover">
						<div>
							设备名称：党建一体机
						</div>
						<div>
							设备状态：{{dang.deviceStatus}}
						</div>
						<div>
							设备位置： {{dang.deviceLocation}}
						</div>
						<el-image style="width: 80px; height: 80px;" :src="require('../assets/dangjian.png')"
							slot="reference"></el-image>
					</el-popover>
				</div>
				<div class="point" style="position: absolute;top: 38%;right: 26%;" @click="goPublicize()">
					<el-popover placement="right-start" title="设备信息" width="200" trigger="hover">
						<div>
							设备名称：智能宣传栏
						</div>
						<div>
							设备状态：{{xuan.deviceStatus}}
						</div>
						<div>
							设备位置：{{xuan.deviceLocation}}
						</div>
						<el-image style="width: 80px; height: 80px;" :src="require('../assets/xuanchuan.png')"
							slot="reference"></el-image>
					</el-popover>
				</div>
			</div>
			<div class="rightBox">
				<div class="statistics">
					<div class="rightTitle">
						商圈客流统计
					</div>
					<div class="statistics_box" id="statistics" :style="{ width: '420px', height: '240px' }">
					</div>
				</div>
				<div class="environmental">
					<div class="rightTitle">
						环境监测数据
					</div>
					<div class="environmentBox">
						<div id="firstBox">
							<div class="firstBox">
								<div class="environmentName">智能宣传栏</div>
								<div class="environmentTip">六合一传感器监测数据</div>
								<div style="width:300px;height:200px;">
									<dv-capsule-chart :config="environmentalConfig1"
										style="width:300px;height:200px;" />
								</div>
							</div>

						</div>
						<div id="otherBox">
							<div class="otherBox">
								<div class="environmentName">智慧指路机</div>
								<div class="environmentTip">六合一传感器监测数据</div>
								<div style="width:300px;height:200px;">
									<dv-capsule-chart :config="environmentalConfig2"
										style="width:300px;height:200px;" />
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="earlyWarning">
					<div class="rightTitle" style="margin-left: 94px;">
						智能感知预警数据
					</div>
					<div class="earlyWarning_box">
						<div class="itemEarly">
							<div class="itemTitle">
								占用安全通道
							</div>
							<div class="itemText">
								{{safeplace}}<span>次</span>
							</div>
						</div>
						<div class="itemEarly">
							<div class="itemTitle">
								重点人员识别
							</div>
							<div class="itemText">
								{{pointhuman}} <span>次</span>
							</div>
						</div>
						<div class="itemEarly">
							<div class="itemTitle">
								突发事件识别
							</div>
							<div class="itemText">
								{{event}}<span>次</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bottomList">
			<div class="bottomTitle">
				义警巡逻打卡数据
			</div>
			<div class="bottomBox">
				<div class="bottomTable">
					<dv-scroll-board :config="bottomTableConfig1" style="width:400px;height:200px" />
				</div>
				<div class="bottomTable">
					<dv-scroll-board :config="bottomTableConfig2" style="width:400px;height:200px" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Switch
	} from 'element-ui';
	var padaDate = function(value) {
		return value < 10 ? '0' + value : value;
	};
	const fullWidth = 300
	const borderGap = 3
	const borderWidth = 3
	const usefulWidth = fullWidth - (borderGap + borderWidth) * 2
	const pieceLength = [0.25, 0.5, 0.25]
	const pieceGap = 3
	const lineDash = pieceLength
		.map(l => [usefulWidth * l, pieceGap])
		.reduce((all, current) => [...all, ...current], [])
	export default {
		name: 'index',
		data() {
			let self = this
			return {
				onezhi: {

				},
				onejing: {

				},
				onexuan: {

				},
				jing: {},
				lu: {},
				deng: {},
				dang: {},
				xuan: {},
				// 年月日 时间  周几
				showFirstBox: true,
				year: '',
				month: '',
				day: '',
				currentDay: '',
				currentTime: '',
				onLineNum: 80, // 设备在线个数
				offLineNum: 20, // 设备离线个数
				scheduleConfig: {
					value: 80,
					colors: ['#856130', '#ffa221'],
					lineDash
				}, // 设备状态
				environmentalConfig1: {
					data: [],
					colors: ['#80dcfe', '#80dcfe', '#80dcfe', '#80dcfe', '#80dcfe', '#80dcfe'],
					// unit: '单位',
					showValue: true
				}, // 环境监测数据配置
				environmentalConfig2: {
					data: [],
					colors: ['#80dcfe', '#80dcfe', '#80dcfe', '#80dcfe', '#80dcfe', '#80dcfe'],
					// unit: '单位',
					showValue: true
				}, // 环境监测数据配置
				environmentalTime: null, // 环境监测数据计时器
				// 义警巡逻打卡数据1 需替换
				bottomTableConfig1: {
					data: [{
							name: `义警巡逻打卡：21日余某某街道巡逻，无危险...`
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: `义警巡逻打卡：21日余某某街道巡逻，无危险...`
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						}
					],
					carousel: "single",
					oddRowBGC: "#000f28",
					evenRowBGC: "#000f28",
					unit: "次",
				},
				// 义警巡逻打卡数据1 需替换
				bottomTableConfig2: {
					data: [{
							name: `义警巡逻打卡：21日余某某街道巡逻，无危险...`
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						},
						{
							name: "义警巡逻打卡：21日余某某街道巡逻，无危险..."
						}
					],
					carousel: "single",
					oddRowBGC: "#000f28",
					evenRowBGC: "#000f28",
					unit: "次",
				},
				safeplace: 56,
				pointhuman: 16,
				event: 22,
				statisticsArr: [], // 商圈客流统计
				emvironmentArr1: [],
				emvironmentArr2: [],
				countTime: null, // 数据+1
				serveData: [],
				chartBox: null,
			}
		},

		mounted() {
			this.chartBox = this.$echarts.init(document.getElementById("serve"))
			this.getTimes() // 页面加载完成后调用函数获取当前时间
			this.getResData()
			this.webSocket()
			this.$nextTick(() => {
				this.getStatistics();
			});
			this.getEmvironmentData()
			this.environmentalTime = setInterval(() => {
				this.changeDiv()
			}, 5000) // 板块展示5秒切换一次
			this.countTime = setInterval(() => {
				this.countAdd()
			}, 3000) // 板块展示3秒切换一次
		},
		beforeDestroy() {
			// 每次切换排行板块时清除上一次的定时器,如果不清除的话切换页面定时器就会失效。切换时间就会有问题
			window.clearInterval(this.environmentalTime)
			this.environmentalTime = null
			
			window.clearInterval(this.countTime)
			this.countTime = null
		},
		methods: {
			countAdd() {
				this.onezhi.egnum >= 999 ? this.onezhi.egnum = 1 : this.onezhi.egnum
				this.onezhi.egnum += 1
				this.onejing.egnum >= 999 ? this.onejing.egnum = 1 : this.onejing.egnum
				this.onejing.egnum += 1
				this.onexuan.egnum >= 999 ? this.onexuan.egnum = 1 : this.onexuan.egnum
				this.onexuan.egnum += 1

				this.safeplace >= 999 ? this.safeplace = 1 : this.safeplace
				this.safeplace += 1
				this.pointhuman >= 999 ? this.pointhuman = 1 : this.pointhuman
				this.pointhuman += 1
				this.event >= 999 ? this.event = 1 : this.event
				this.event += 1
				
				
				this.serveData.forEach(function(item) {
					item.value++
				})
				this.$nextTick(() => {
					this.getServe();
				});
			},
			// 切换板块方法
			changeDiv() {
				let firstBox = document.getElementById('firstBox');
				let otherBox = document.getElementById('otherBox');
				if (firstBox.style.display === 'none') {
					firstBox.style.display = 'block';
					otherBox.style.display = 'none'
				} else {
					firstBox.style.display = 'none';
					otherBox.style.display = 'block'
				}
			},
			getEmvironmentData() {
				this.axios.get('https://zydevice.tzdingtalk.cn/prod-api/h5/environment/list', {}).then((resp) => {
					this.emvironmentArr1 = resp.data.rows.filter((item) => {
						return item.deviceType == "多功能宣传栏"
					})

					this.emvironmentArr1 = this.emvironmentArr1.map((v) => {
						return {
							'01-甲醛': v.ch2o,
							'02-二氧化碳': v.co2,
							// 'deviceType':v.deviceType,
							// 'environmentId': v.environmentId,
							'03-pm2.5': v.pm25,
							'04-温度': v.temperture,
							'05-tvoc': v.tvoc,
							'06-PMI0': 0.1,
						}
					})
					this.emvironmentArr2 = resp.data.rows.filter((item) => {
						return item.deviceType == "智慧指路机"
					})
					this.emvironmentArr2 = this.emvironmentArr2.map((v) => {
						return {
							'01-甲醛': v.ch2o,
							'02-二氧化碳': v.co2,
							// 'deviceType':v.deviceType,
							// 'environmentId': v.environmentId,
							'03-pm2.5': v.pm25,
							'04-温度': v.temperture,
							'05-tvoc': v.tvoc,
							'06-PMI0': 0.1,
						}
					})
					const emObj1 = this.emvironmentArr1[0]
					const emObj2 = this.emvironmentArr2[0]
					const newArr = Object.keys(emObj1).map(key => {
						return {
							name: key,
							value: emObj1[key]
						}
					});
					this.environmentalConfig1.data = newArr
					this.environmentalConfig1 = {
						...this.environmentalConfig1
					}
					const newArr1 = Object.keys(emObj2).map(key => {
						return {
							name: key,
							value: emObj2[key]
						}
					});
					this.environmentalConfig2.data = newArr1
					this.environmentalConfig2 = {
						...this.environmentalConfig2
					}
				})
			},
			webSocket() {
				const url = 'wss://zydevice.tzdingtalk.cn/prod-api/websocket/message'
				const connection = new WebSocket(url);
				connection.onopen = (event) => {
					let obj = event.data

					if (obj.status == 'Emergency') {
						if (obj.computerid == '17114485835952741026') {
							console.log('我是室外紧急情况')
							const h = this.$createElement;
							this.$msgbox({
								title: '警告',
								message: h('p', null, [
									h('span', {
										style: 'color: red,fontSize:26px'
									}, '室外指路机出现紧急情况')
								]),
								type: 'warning',
								center: true,
								showCancelButton: false,
								showConfirmButton: false,
							})
							setTimeout(() => {
								this.$msgbox.close()
							}, 3000)
						} else if (obj.computerid == '1711071758795286677') {
							const h = this.$createElement;
							this.$msgbox({
								title: '警告',
								message: h('p', null, [
									h('span', {
										style: 'color: red,fontSize:26px'
									}, '室内指路机出现紧急情况')
								]),
								type: 'warning',
								center: true,
								showCancelButton: false,
								showConfirmButton: false,
							})
							setTimeout(() => {
								this.$msgbox.close()
							}, 3000)
						} else {
							console.log('我什么都不是')
						}
					}


					// setTimeout(, 30);

				}
				connection.onmessage = (event) => {

				}
				connection.onerror = (event) => {
					console.log('onerror')
				}

			},
			getResData() {
				// 设备数据
				this.axios.get('https://zydevice.tzdingtalk.cn/prod-api/h5/devicestatus/list', {}).then((resp) => {
					const resData = resp.data.rows

					let num = ''
					for (var i in resData) {

						num += Number(resData[i].deviceStatus);

						resData[i].deviceStatus == 1 ? resData[i].deviceStatus = '在线' : resData[i].deviceStatus =
							'离线'
						switch (resData[i].deviceName) {
							case '智能报警柱':
								this.jing = resData[i]
								break;
							case '智能指路机':
								this.lu = resData[i]
								break;
							case '数字坐凳':
								this.deng = resData[i]
								break;
							case '党建一体机':
								this.dang = resData[i]
								break;
							case '智能宣传栏':
								this.xuan = resData[i]
								break;
						}
					}
				})
				this.axios.get('https://zydevice.tzdingtalk.cn/prod-api/h5/emergency/list', {

				}).then((resp) => {
					this.onezhi = resp.data.rows.filter((item) => {
						return item.deviceType == "智能指路机"
					})[0]
					this.onejing = resp.data.rows.filter((item) => {
						return item.deviceType == "智能报警柱"
					})[0]
					this.onexuan = resp.data.rows.filter((item) => {
						return item.deviceType == "智能宣传栏"
					})[0]
				})
				this.axios.get('https://zydevice.tzdingtalk.cn/prod-api/h5/camera/list', {

				}).then((resp) => {
					this.event = resp.data.rows[0].event
					this.safeplace = resp.data.rows[0].safeplace
					this.pointhuman = resp.data.rows[0].pointhuman
				})
				this.axios.get('https://zydevice.tzdingtalk.cn/prod-api/h5/service/list', {

				}).then((resp) => {
					this.serveData = resp.data.rows.map((v) => {
						return {
							name: v.deviceType,
							value: v.serviceNum
						}
					})
					console.log('接口', this.serveData)
					this.$nextTick(() => {
						this.getServe();
					});
				})
			},
			goGuide() {
				let firstBox = document.getElementById('firstBox');
				let otherBox = document.getElementById('otherBox');
				firstBox.style.display = 'block';
				otherBox.style.display = 'none'
			},
			goPublicize() {
				let firstBox = document.getElementById('firstBox');
				let otherBox = document.getElementById('otherBox');
				firstBox.style.display = 'none';
				otherBox.style.display = 'block'
			},
			goSystem() {
				window.open('https://zydevice.tzdingtalk.cn/system/user')
			},
			goVideo() {
				window.open('https://zydevice.tzdingtalk.cn/VideoManager')
			},
			goDevice() {
				window.open('https://zydevice.tzdingtalk.cn/DeviceManager/digitalmachine')
			},
			goApplication() {
				window.open('https://zydevice.tzdingtalk.cn/Device/DMplace')
			},
			goMap() {
				window.open('https://zydevice.tzdingtalk.cn/MapManager/map')
			},
			// 获取时间
			getTimes() {
				setInterval(this.getTimesInterval, 1000);
			},
			getTimesInterval: function() {
				let _this = this;
				let year = new Date().getFullYear(); //获取当前时间的年份
				let month = new Date().getMonth() + 1; //获取当前时间的月份
				let day = new Date().getDate(); //获取当前时间的天数
				let hours = new Date().getHours(); //获取当前时间的小时
				let minutes = new Date().getMinutes(); //获取当前时间的分数
				let seconds = new Date().getSeconds(); //获取当前时间的秒数
				let days = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
				let today = new Date();
				let weekday = today.getDay();
				this.currentDay = days[weekday];
				//当小于 10 的是时候，在前面加 0
				if (hours < 10) {
					hours = "0" + hours;
				}
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				this.year = year //格式化之后的当前时间
				this.month = month,
					this.day = day,
					this.currentTime = hours + ":" + minutes + ":" + seconds
			},

			// 获取服务次数数据
			getServe() {
				console.log(this.serveData, '222222222222222222222222')
				var colorList = ['#00addb', '#008ab6', '#0078a0', '#005376', '#033857', "rgba(0,0,0,0)"];

				const option = {
					series: [{
							radius: ['15%', '51%'],
							center: ['50%', '50%'],
							type: 'pie',
							itemStyle: {
								normal: {
									color: function(params) {
										return colorList[params.dataIndex]
									}
								}
							},
							labelLine: {
								normal: {
									show: true,
									length: 15,
									length2: 120,
									lineStyle: {
										color: '#d3d3d3'
									},
									align: 'right'
								},
								color: "#000",
								emphasis: {
									show: true
								}
							},
							label: {
								normal: {
									formatter: function(params) {
										var str = '';
										switch (params.name) {
											case '数字人问答':
												str = '{a|}\n{nameStyle|数字人问答 }' + '{rate|' +
													params.value +
													'次}';
												break;
											case '指路服务':
												str = '{b|}\n{nameStyle|指路服务 }' + '{rate|' +
													params
													.value +
													'次}';
												break;
											case '一键报警':
												str = '{c|}\n{nameStyle|一键报警 }' + '{rate|' + params
													.value +
													'次}';
												break;
											case '义警巡逻打卡':
												str = '{d|}\n{nameStyle|义警巡逻打卡 }' + '{rate|' +
													params.value +
													'次}';
												break;
											case '环境实时监测':
												str = '{e|}\n{nameStyle|环境实时监测 }' + '{rate|' +
													params.value +
													'次}';
												break;
										}
										return str
									},
									padding: [0, -110],
									height: 165,
									rich: {
										a: {
											width: 38,
											height: 38,
											lineHeight: 50,
											align: 'left'
										},
										b: {
											width: 29,
											height: 45,
											lineHeight: 50,
											align: 'left'
										},
										c: {
											width: 34,
											height: 33,
											lineHeight: 50,
											align: 'left'
										},
										d: {
											width: 34,
											height: 44,
											lineHeight: 50,
											align: 'left'
										},
										e: {
											width: 38,
											height: 30,
											lineHeight: 50,
											align: 'left'
										},
										nameStyle: {
											fontSize: 16,
											color: "#d6ffff",
											align: 'left'
										},
										rate: {
											fontSize: 20,
											color: "#d5db24",
											align: 'left'
										}
									}
								}
							},
							// 接入数据
							data: this.serveData,
						},
						// 边框的设置
						{
							radius: ['47%', '51%'],
							center: ['50%', '50%'],
							type: 'pie',
							label: {
								normal: {
									show: false
								},
								emphasis: {
									show: false
								}
							},
							labelLine: {
								normal: {
									show: false
								},
								emphasis: {
									show: false
								}
							},
							animation: false,
							tooltip: {
								show: false
							},
							itemStyle: {
								normal: {
									color: 'rgba(250,250,250,0.5)'
								}
							},
							data: [{
								value: 1,
							}],
						}
					]
				};
				this.chartBox.setOption(option);
				// 根据页面大小自动响应图表大小
				window.addEventListener("resize", function() {
					this.chartBox.resize();
				});

			},
			// 商圈客流统计
			getStatistics() {
				var chartBox = this.$echarts.init(document.getElementById("statistics"))
				this.axios.get('https://zydevice.tzdingtalk.cn/prod-api/h5/humancount/list', {

				}).then((resp) => {
					var data = resp.data.rows.map((v) => {
						return v.humancount
					})
					var xdata = resp.data.rows.map((v) => {
						return v.timedata.slice(5)
					})
					var option = {
						xAxis: {
							type: 'category',
							data: xdata, // 替换数据
							triggerEvent: true,
							splitLine: {
								show: false
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 2,
									color: '#001329'
								}
							},
							axisTick: {
								show: true
							},
							axisLabel: {
								color: '#ffff1c',
								fontSize: 16,
							}
						},
						yAxis: {
							nameTextStyle: {
								color: '##001329',
								fontSize: 16
							},
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									color: '#001329'
								}
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 2,
									color: '#001329'
								}
							},
							axisTick: {
								show: true
							},
							axisLabel: {
								color: '#001329',
								fontSize: 16,
							}
						},
						series: [{
							data: data, // 替换数据
							type: 'line',
							symbol: 'circle',
							symbolSize: 4,
							color: '#FEC201',
							lineStyle: {
								color: "#03E0F2"
							},
							label: {
								show: true,
								position: 'top',
								textStyle: {
									color: '#dbe020',
									fontSize: 16
								}
							},
							areaStyle: {
								color: 'rgba(1,98,133,0.6)'
							}
						}, {
							type: 'bar',
							animation: false,
							barWidth: 3,
							hoverAnimation: false,
							data: data,
							tooltip: {
								show: true
							},
							itemStyle: {
								normal: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
											offset: 0,
											color: '#91EAF2' // 0% 处的颜色
										}, {
											offset: 1,
											color: '#074863' // 100% 处的颜色
										}],
										globalCoord: false // 缺省为 false
									},
									label: {
										show: false
									}
								}
							}
						}]
					}
					chartBox.setOption(option);
					// 根据页面大小自动响应图表大小
					window.addEventListener("resize", function() {
						chartBox.resize();
					});
				})


			}
		}
	}
</script>

<style>
	body {
		margin: 0;
		padding: 0;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		overflow-x: hidden;
	}

	img {
		-webkit-user-drag: none;
	}

	.container {
		width: 1920px;
		height: 1080px;
		padding: 0;
		margin: 0;
		background-image: url('~@/assets/bg.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		overflow: hidden;
	}


	.header {
		width: 1920px;
		height: 164px;
		background-image: url('~@/assets/headerbg.png');
		background-size: cover;
		background-repeat: no-repeat;
	}

	.nav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		color: #caf7fb;
		height: 46px;
		text-align: center;
		line-height: 46px;
		font-size: 18px;
		padding-top: 110px;
	}

	.left_nav_box,
	.right_nav_box {
		width: 400px;
		display: flex;
		flex-direction: row;
	}

	.left_nav_box {
		padding-left: 100px;
	}

	.right_nav_box {
		padding-right: 100px;
	}

	.leftNav,
	.rightNav {
		width: 820px;
		height: 46px;
		margin-right: 20px;
		color: #97c1cd;
	}

	.leftNav {
		background-image: url('~@/assets/leftheader.png');
		background-size: 100% 100%;
	}

	.leftNav:hover,
	.rightNav:hover {
		/* border: 1px solid #d0fcff; */
		box-shadow: #d0fcff;
		color: #d0fcff;
	}

	.rightNav {
		background-image: url('~@/assets/rightheader.png');
		background-size: 100% 100%;
	}

	.weather {
		width: 1120px;
		height: 46px;
		margin-top: 14px;
		font-size: 14px;
		line-height: 56px;
	}

	.content {
		width: 1920px;
		height: 816px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.leftBox {
		width: 660px;
		display: flex;
		flex-direction: column;
	}

	.runstatus {
		width: 520px;
		height: 254px;
		background-image: url('~@/assets/runstatus.png');
		background-size: 100% 100%;
		margin-top: 28px;
		margin-left: 56px;
		color: #fff;
	}

	.tip {
		color: #0bcdc5;
		margin: 0 auto;
		margin: 50px 0 6px 120px;
	}

	.statusBox {
		width: 62%;
		display: flex;
		flex-direction: row;
		margin: 0 auto;
	}

	.online_box,
	.offline_box {
		height: 50px;
		font-size: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;

	}

	.online_box {
		width: 144px;
		background-image: url('~@/assets/online.png');
		background-size: 100% 100%;
	}

	.offline_box {
		width: 56px;
		background-image: url('~@/assets/offline.png');
		background-size: 100% 100%;
	}

	.dv-percent-pond text {
		display: none !important;
	}

	.leftTitle,
	.rightTitle {
		color: #b6e6ec;
		text-align: center;
		font-size: 15px;
		line-height: 24px;
	}

	.leftTitle {

		float: right;
		margin-right: 84px;

	}

	.rightTitle {

		float: left;
		margin-left: 106px;

	}

	.oneclick {
		width: 500px;
		height: 254px;
		background-image: url('~@/assets/oneclick.png');
		background-size: 100% 100%;
		margin-top: 6px;
		margin-left: 62px;
	}

	.oneClick_box {
		width: 260px;
		height: 154px;
		/* border: 1px solid green; */
		background-image: url('~@/assets/jing.png');
		background-size: 100% 100%;
		/* margin-top: 6px; */
		margin-left: 62px;
	}

	.serve {
		width: 530px;
		height: 254px;
		background-image: url('~@/assets/serve.png');
		background-size: 100% 100%;
		margin-top: 6px;
		margin-left: 46px;
	}

	.map {
		width: 900px;
		height: 700px;
		margin-top: 40px;
		background-image: url('~@/assets/map.png');
		background-size: 100% 100%;
		position: relative;
	}

	.rightBox {
		width: 660px;
		display: flex;
		flex-direction: column;
	}

	.statistics {
		width: 526px;
		height: 254px;
		background-image: url('~@/assets/statistics.png');
		background-size: 100% 100%;
		margin-top: 28px;
	}

	.statistics_box {
		margin: 0 auto;
		margin-top: 20px;
	}

	.environmental {
		width: 505px;
		height: 254px;
		background-image: url('~@/assets/environmental.png');
		background-size: 100% 100%;
		margin-top: 6px;
		margin-left: 16px;
	}

	.environmentBox {
		color: #fff;
		width: 75%;
		margin: 30px auto;
	}

	#firstBox {}

	#otherBox {
		display: none;

	}

	.firstBox,
	.otherBox {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
	}

	.environmentName {
		border: 1px solid rgb(112, 197, 230);
		width: 20px;
		height: 170px;
		display: flex;
		align-items: center;
		padding: 0px 2px;
		color: rgb(170, 238, 248);
		margin-right: 14px;
		text-align: center;
		line-height: 26px;
		font-size: 14px;
	}

	.environmentTip {
		width: 17px;
		align-items: center;
		color: rgb(215, 130, 10);
		font-size: 10px;
		line-height: 18px;
	}

	.earlyWarning {
		width: 484px;
		height: 254px;
		background-image: url('~@/assets/earlyWarning.png');
		background-size: 100% 100%;
		margin-top: 6px;
		position: relative;
	}

	.earlyWarning_box {
		position: absolute;
		top: 60px;
		left: 70px;
		display: flex;
		flex-direction: row;
		justify-content: space-around;

	}

	.itemEarly {
		margin-right: 10px;
	}

	.itemTitle {
		width: 106px;
		height: 26px;
		border: 1px solid #a3e4ef;
		background-color: #11324a;
		color: #a3e4ef;
		text-align: center;
		font-size: 14px;
		line-height: 26px;
	}

	.itemText {
		width: 106px;
		height: 96px;
		font-size: 34px;
		line-height: 96px;
		text-align: center;
		background-color: #143e5b;
		color: #f8f91d;
		border: 1px solid #143e5b;

	}

	.itemText span {
		font-size: 14px;
	}

	.bottomList {
		width: 800px;
		height: 200px;
		margin: 0 auto;
		margin-bottom: 100px;

	}

	.bottomTitle {
		width: 180px;
		height: 40px;
		margin: 0 auto;
		margin-top: -60px;
		color: #73eb67;
		line-height: 40px;
		text-align: center;
		background-image: url('~@/assets/bottombg.png');
		background-size: 100% 100%;
	}

	.bottomBox {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.dv-scroll-board .rows .ceil {

		color: #556f96 !important;
	}

	.dv-scroll-board .rows .ceil::before {
		content: "" !important;
		display: inline-block !important;
		background-image: url("~@/assets/green.png") !important;
		width: 30px !important;
		height: 30px !important;
		margin-right: 4px !important;
	}

	.environmentBox {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin: 0 auto;
	}

	.dv-capsule-chart .label-column div {
		border: 1px solid #f29913 !important;
		text-align: center !important;
	}

	.dv-capsule-chart .unit-label {
		display: none !important;
	}

	.dv-capsule-chart .capsule-item .capsule-item-column .capsule-item-value {
		color: #8fd2df !important;
	}

	.dv-capsule-chart .capsule-item .capsule-item-column {
		border-radius: unset !important;
	}

	.dv-capsule-chart .capsule-item {
		border-radius: unset !important;
	}

	.dv-capsule-chart .capsule-item {
		margin: 10px 0px !important;

	}

	.dv-capsule-chart .label-column div {
		margin: 4px 0 !important;
		padding: 0 6px !important;
		font-size: 12px !important;
	}

	/* label-column */
	.dv-capsule-chart .label-column div:nth-last-child(1) {
		border: unset !important;
		display: none !important;
	}

	::-webkit-scrollbar {
		width: 5px;
		/* 纵向滚动条 宽度 */
		height: 15px;
		/* 横向滚动条 高度 */
		background: #001629;
		/* 整体背景 */
		border-radius: 10px;
		/* 整体 圆角 */
	}

	/* 4.内层轨道，它会覆盖外层轨道的样式。 */
	::-webkit-scrollbar-track-piece {
		width: 5px;
		background-color: #0a3859;
		margin: 0 -2px 0;
		border-radius: 10px;
	}

	/* 5,滑块 */
	::-webkit-scrollbar-thumb {
		background: #001629;
		min-height: 0px;
		min-width: 50px;
		border-radius: 10px;
	}

	.el-popover {
		width: 246px !important;
		height: 160px !important;
		border: 1px solid #13d1c5 !important;
		background: #02142c !important;
		color: #fff !important;
	}

	.el-popover__title {
		color: #fff !important;
	}

	.el-popper .popper__arrow {
		display: none !important;
	}
</style>